import { useQuery } from '@tanstack/react-query';
import { fetchPlan } from '../services/plans';

export const planQueryKey = (id: string) => ['smr-admin', 'plan', id];

export function usePlanQuery(id: string) {
    return useQuery({
        queryKey: planQueryKey(id),
        queryFn: () => fetchPlan(id),
        enabled: Boolean(id),
    });
}
